// The "How to print" guide for price stickers on the Brother label printer (62 mm roll). Steps come from Umut. This is the
// built-in version, shown until a Super Admin first saves the guide; after that the server's copy (backend/guide.js) is shown.
//
// Every step and picture has its own id. A step points at its picture by that id, never by number, so adding, removing or
// moving steps (or pictures) never changes which picture belongs to which step.

export interface Step { id: string; text: string; detail?: string; image?: string }
export interface GuideImage { id: string; caption: string }
// A guide's own download button (e.g. a program to install), or null for none.
export interface GuideLink { label: string; url: string }
export interface Guide { id: string; tab: string; title: string; intro: string; link: GuideLink | null; steps: Step[]; images: GuideImage[] }

export const ADOBE_READER_URL = 'https://get.adobe.com/reader/';
export const imageUrl = (id: string) => `/api/guide/images/${id}`;
export const ADOBE_LINK: GuideLink = { label: 'Download Adobe Acrobat Reader (free)', url: ADOBE_READER_URL };

// Guides saved before each guide had its own download button have no `link` at all: the "adobe" one keeps the Adobe Reader
// button it always showed, the others get none.
export const withLinks = (guides: Guide[]): Guide[] =>
  guides.map((g) => (g.link === undefined ? { ...g, link: g.id === 'adobe' ? ADOBE_LINK : null } : g));

export const GUIDES: Guide[] = [
  {
    id: 'adobe',
    tab: 'Adobe Reader (easy)',
    title: 'Using Adobe Reader',
    intro: 'The easiest way. Adobe Acrobat Reader is free.',
    link: ADOBE_LINK,
    steps: [
      { id: 'a1', text: 'Open the PDF in Adobe Reader.' },
      { id: 'a2', text: 'Click Print and choose the Brother printer.' },
      { id: 'a3', text: 'Click Properties.' },
      { id: 'a4', text: 'Set the paper size to 62 mm.' },
      { id: 'a5', text: 'Set the height to 12.7.', detail: 'If you enter 0, it sets itself to 12.7.' },
      { id: 'a6', text: 'Click Print.' },
    ],
    images: [],
  },
  {
    id: 'chrome',
    tab: 'Chrome browser (more steps)',
    title: 'Using the Chrome browser',
    intro: 'Works without installing anything, but takes more steps.',
    link: null,
    steps: [
      { id: 'c1', text: 'Connect the printer to the computer.' },
      { id: 'c2', text: 'Open the PDF in Chrome.' },
      { id: 'c3', text: 'Click Print and choose the Brother printer.' },
      { id: 'c4', text: 'Paper size: 12 mm.' },
      { id: 'c5', text: 'Scale: Fit to paper.' },
      { id: 'c6', text: 'Click More settings.' },
      { id: 'c7', text: 'Click Print using system dialog.' },
      { id: 'c8', text: 'Choose the printer and click More settings.' },
      { id: 'c9', text: 'Paper size: 62 mm.' },
      { id: 'c10', text: 'Set the length to 12.7.', detail: 'If you enter 0, it sets itself to 12.7.' },
      { id: 'c11', text: 'Feed: 3 mm.' },
      { id: 'c12', text: 'Orientation: Portrait.' },
      { id: 'c13', text: 'Click Print.' },
    ],
    images: [],
  },
];
